(() => {
  const SEARCH_GAP = 12;

  customElements.whenDefined('header-search').then(() => {
    const proto = customElements.get('header-search').prototype;
    const originalHide = proto.hide;
    const originalShow = proto.show;

    const getHeaderBar = () => document.querySelector('.shopify-section--header x-header.header');

    const getSearchContent = (element) => {
      if (typeof element.getShadowPartByName === 'function') {
        return element.getShadowPartByName('content');
      }

      return element.shadowRoot?.querySelector('[part="content"]') || null;
    };

    const syncSearchOffset = (element) => {
      const headerBar = getHeaderBar();
      if (!headerBar) {
        return;
      }

      const top = Math.round(headerBar.getBoundingClientRect().bottom + SEARCH_GAP);

      document.documentElement.style.setProperty('--header-search-top', `${top}px`);
      element.style.setProperty('--header-search-top', `${top}px`);

      const content = getSearchContent(element);
      if (content) {
        content.style.setProperty('inset-block-start', `${top}px`);
        content.style.setProperty('margin-block-start', '0px');
      }
    };

    Object.defineProperty(proto, 'shouldAppendToBody', {
      get() {
        return true;
      },
      configurable: true,
    });

    proto.show = function showHeaderSearch(...args) {
      this.classList.remove('is-closing');
      syncSearchOffset(this);
      const result = originalShow.apply(this, args);
      Promise.resolve(result).finally(() => {
        syncSearchOffset(this);
        requestAnimationFrame(() => syncSearchOffset(this));
      });
      return result;
    };

    proto.hide = function hideHeaderSearch() {
      if (!this.open) {
        return Promise.resolve();
      }

      this.classList.add('is-closing');
      return originalHide.call(this);
    };

    document.addEventListener('dialog:after-hide', (event) => {
      if (event.target instanceof HTMLElement && event.target.localName === 'header-search') {
        event.target.classList.remove('is-closing');
      }
    });

    window.addEventListener('resize', () => {
      document.querySelectorAll('header-search[open]').forEach((element) => {
        syncSearchOffset(element);
      });
    });
  });
})();
